import { useState } from 'react'
import { useStore } from '../store/store'
import { Banner, Button, Card, PageHead, Pill, SelectField, Toggle } from '../components/ui'

const JURISDICTIONS = ['United States', 'United Kingdom', 'European Union', 'Canada', 'Australia', 'Other / Not listed', 'unset']

const DOES = [
  'Research, education, journaling and paper trading',
  'Convert odds, remove vig and compute expected value',
  'Size positions with conservative, capped fractional Kelly',
  'Simulate risk of ruin and drawdowns before you risk money',
  'Track calibration so you learn if your probabilities are honest',
  'Show uncertainty, assumptions and downside on every idea',
  'Offer a clear "No Trade / No Bet" when the edge is weak',
]

const DOES_NOT = [
  'Place real-money trades or bets automatically',
  'Bypass KYC, geo-restrictions, paywalls, rate limits or terms of service',
  'Scrape private logged-in pages',
  'Promise profit or output "sure win" picks',
  'Provide financial, investment, legal or betting advice',
  'Encourage betting in markets that are illegal where you live',
]

export function LegalSafety() {
  const meta = useStore((s) => s.meta)
  const setJurisdiction = useStore((s) => s.acceptDisclaimer)
  const paperFirst = useStore((s) => s.meta.paperFirstMode)
  const setPaperFirst = useStore((s) => s.setPaperFirst)
  const [jur, setJur] = useState(meta.jurisdiction)

  return (
    <div className="stack">
      <PageHead title="Legal & Safety">
        EdgeLab only supports legal markets in legal jurisdictions, and defaults to paper trading. Read this, and keep it in mind every session.
      </PageHead>

      <Banner tone="danger" icon={'\u26A0'}>
        <strong>Trading and betting can lose money — potentially all of it.</strong> No model here guarantees profit, and past performance never predicts the future. You alone are responsible for your decisions and for obeying the law where you live.
      </Banner>

      <div className="grid cols-2">
        <Card title="What EdgeLab does">
          <ul style={{ paddingLeft: 18, margin: 0 }} className="muted">
            {DOES.map((d, i) => (
              <li key={i} style={{ marginBottom: 4 }}>{d}</li>
            ))}
          </ul>
        </Card>
        <Card title="What EdgeLab will not do">
          <ul style={{ paddingLeft: 18, margin: 0 }} className="muted">
            {DOES_NOT.map((d, i) => (
              <li key={i} style={{ marginBottom: 4 }}><span className="neg">{'\u2717'}</span> {d}</li>
            ))}
          </ul>
        </Card>
      </div>

      <Card title="Your settings">
        <div className="grid cols-2">
          <SelectField label="Jurisdiction" value={jur} onChange={setJur} options={JURISDICTIONS.map((j) => ({ value: j, label: j === 'unset' ? 'Not set' : j }))} />
          <div style={{ display: 'flex', alignItems: 'flex-end' }}>
            <Button onClick={() => setJurisdiction(jur)}>Save jurisdiction</Button>
          </div>
        </div>
        <Toggle label="Paper-first mode (new ideas default to paper trading)" checked={paperFirst} onChange={setPaperFirst} />
        <div className="row" style={{ gap: 8, marginTop: 8 }}>
          <Pill tone={meta.acceptedLegalDisclaimer ? 'green' : 'red'}>{meta.acceptedLegalDisclaimer ? 'Disclaimer accepted' : 'Disclaimer pending'}</Pill>
          <Pill tone="gray">Jurisdiction: {meta.jurisdiction}</Pill>
        </div>
      </Card>

      <Card title="Bet and trade responsibly">
        <p className="muted" style={{ marginTop: 0 }}>
          If betting or trading stops being fun, starts chasing losses, or affects your finances, relationships or sleep, take a break. Use deposit limits and self-exclusion tools offered by regulated operators, and seek a local responsible-gambling helpline if you need support. Set a budget you can afford to lose — and never exceed it to "get even".
        </p>
      </Card>
    </div>
  )
}
